<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{ $t('insurance_companies')}}</h4>
                <p class="text-subtitle-1">{{ $t('list_of_insurance_companies')}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.insurance_company.create)">
                <v-btn block color="primary" @click="handleNew">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("new_insurance_company")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            block 
                            depressed 
                            v-on="on"
                            v-bind="attrs">
                            <v-icon left>mdi-magnify</v-icon>
                            {{ $t('search') }}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Name"
                                        v-model="form.name"
                                        @keypress.enter="fetchDriversWithSearch"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Phone"
                                        v-model="form.phone"
                                        @keypress.enter="fetchWithSearch"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col>
                                    <v-btn block color="primary" @click="fetchWithSearch">
                                        submit
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    :loading="loading"
                    :options.sync="options"
                    :page.sync="page"
                    disable-sort
                    :footer-props="footerProps"
                    :server-items-length="serverItemsLength"
                >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="handleClickRow(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import authorize from './../../../../utils/authorize';
import insurance from './../../../../services/insurance/company';
import permissions from '../../../../data/permissions';

export default {
    data() {
        return {
            headers: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("phone"), value: "phone" },
            ],
            footerProps: {
                'items-per-page-options': [10, 25, 50, 100]
            },
            data: [],
            loading: false,
            options: {},
            serverItemsLength: 0,
            form: {
                name: "",
                phone: ""
            },
            page: 1,
            permissions
        }
    },
    watch: {
        options() {
            this.fetch()
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetch() {
            this.items = [];
            this.loading = true;
            insurance.index({...this.options, ...this.form}).then(response => {
                this.data = response.data.data;
                this.serverItemsLength = response.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchWithSearch() {
            this.page = 1;
            this.fetch();
        },
        handleClickRow(item) {
            this.$router.push({ name: "InsuranceCompanyDisplay" , params: { id : item.id } })
        },
        handleNew() {
            this.$router.push({ name: 'InsuranceCompanyCreate' });
        }
    },
    created() {
        
    }
}
</script>

<style>

</style>